import { HIGHLIGHT_TYPES } from 'modules/codeless-events/consts/iframeParentConstants';
import { useElementHighlighter } from './useElementHighlighter';

const valueSelector = [
    'span',
    'p',
    'label',
    'td',
    'th',
    'li',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    '[class*="price"]',
    '[class*="value"]',
    '[class*="amount"]',
    '[class*="cost"]',
    '[class*="total"]',
    '[class*="sum"]',
    '[class*="currency"]',
    '[class*="money"]', // Common data attributes
    '[data-price]',
    '[data-amount]',
    '[data-value]',
].join(', ');

const NUMERIC_VALUE_REGEX = '\\d+(\\.\\d+)?';

const extractNumericValue = text => {
    const matches = text.match(new RegExp(NUMERIC_VALUE_REGEX));
    if (!matches) {
        return null;
    }
    return parseFloat(matches[0].replace(/,/g, ''));
};

export const useValueHighlighter = ({ isHighlighting, onValueClick }) => {
    const handleValueClick = ({ eventName, path }) => {
        const value = extractNumericValue(eventName);
        onValueClick({
            path,
            value,
        });
    };

    return useElementHighlighter({
        selector: valueSelector,
        onElementClick: handleValueClick,
        highlightType: HIGHLIGHT_TYPES.VALUE,
        isHighlighting,
        regex: NUMERIC_VALUE_REGEX,
    });
};
